import { useContext, useState } from "react"
import { AppContext } from "../context/createContext"
import useReize from "../helpers/useResize"

const useSoundSwitcher = () => {
  const {
    appFuncs: { setisMusicOff, setisSoundOff },
    audio: { isMusicOff, isSoundOff },
  } = useContext(AppContext)

  const [prevSounds, setPrevSounds] = useState({
    music: isMusicOff,
    sound: isSoundOff,
  })
  const { isMobile } = useReize()

  if (isMobile) {
    window.onfocus = function () {
      setisMusicOff(prevSounds.music)
      setisSoundOff(prevSounds.sound)
    }

    window.onblur = function () {
      setPrevSounds({
        music: isMusicOff,
        sound: isSoundOff,
      })
      setisMusicOff(true)
      setisSoundOff(true)
    }
  }
}

export default useSoundSwitcher
